/**
 * Sentry Error Boundary
 *
 * This component wraps the entire application and provides:
 * - Automatic error capture to Sentry
 * - Graceful error UI for users
 * - Error recovery options
 */

import * as Sentry from '@sentry/react'
import { ErrorFallbackUI } from '@/components/shared/ErrorFallbackUI'

/**
 * Sentry-wrapped Error Boundary
 *
 * This automatically captures errors and sends them to Sentry,
 * then displays a user-friendly fallback UI.
 */
export const SentryErrorBoundary = Sentry.withErrorBoundary(
    ({ children }: { children: React.ReactNode }) => <>{children}</>,
    {
        fallback: ({ error }) => (
            <ErrorFallbackUI error={error instanceof Error ? error : null} />
        ),
        showDialog: false,
    }
)
